<template>
  <div>
    <div v-show="!loading">
      <div class="tab-bar">
        <h2>{{ pageTitle }}</h2>
        <div class="action">
          <v-btn
            color="primary"
            :loading="form.$busy"
            @click="showModal = true"
            large
            >Save</v-btn
          >
        </div>
      </div>
      <content-editor class="my-3" v-model="form.content" />
    </div>
    <v-container v-show="loading" style="height: 400px;">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="subtitle-1 text-center" cols="12">
          Loading Content
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="primary accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>

    <ConfirmModal
      v-model="showModal"
      title=""
      message="Are you sure you want to save your changes?"
      @cancel="showModal = false"
      @confirm="save"
    ></ConfirmModal>
  </div>
</template>
<script>
import ContentEditor from './components/ContentEditor.vue'
import Form from '@/utils/form'
import get from 'lodash/get'
import ConfirmModal from '@/components/modals/ConfirmModal'

export default {
  props: {
    pageTitle: {
      type: String,
      required: true
    },
    pageType: {
      type: String,
      required: true
    }
  },
  components: {
    ContentEditor,
    ConfirmModal
  },
  data() {
    return {
      loading: true,
      form: new Form({
        // type: this.pageType,
        content: null
      }),
      showModal: false
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        this.loading = true
        const response = await this.$api.get(
          // `admin/settings/pages/${this.form.type}`
          this.pageType
        )
        this.form.content = get(response, 'data.data.content')
      } finally {
        this.loading = false
      }
    },
    async save() {
      const path = `admin/settings/pages/${this.pageType}`
      this.showModal = false

      try {
        this.form.$busy = true
        await this.$api.post(path, this.form.$data())
      } finally {
        this.form.$busy = false
        this.$router.push({ name: 'settings' })
      }
    }
  }
}
</script>
<style scoped>
.tab-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
}
</style>
